import CRUDFormComponent from '../../components/CRUDFormComponent'

const HealthInsurancesForm = () => {
  const fields = [{ key: 'name', label: 'Nombre', type: 'string' }]

  return (
    <>
      <CRUDFormComponent
        entityName={{ singular: 'Isapre' }}
        fields={fields}
        entityUrl="/health-insurances"
      />
    </>
  )
}

export default HealthInsurancesForm
